var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.9998 0c2.6376 0 4.7857 2.0835 4.7857 4.6461l-4.69e-4 2.5919 1.615 9.189e-4v8.7611h-12.8v-8.7611l1.614-9.189e-4 5.308e-4 -2.5915c0-2.563 2.1468-4.6465 4.7852-4.6465zm0 2.0986c-1.4466 0-2.6242 1.1425-2.6242 2.5475l-5.524e-4 2.5919h5.247l6.661e-4 -2.5919c0-1.405-1.1767-2.5475-2.6229-2.5475z",
    fill: "#454545",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.705c884ec0938a2d9e81d13e0ddd8c08.svg";
export { ForwardRef as ReactComponent };